<template>
  <v-container fluid>
    <v-form ref="form" v-model="formValid" lazy-validation>
      <v-col cols="12" style="margin-top: 2%">
        <template v-if="idCuadrillaSesion == ''">
          <v-text-field
            :append-icon="'mdi-eye'"
            v-model="observacion"
            required
            label="Observacion"
            dense
            outlined
          ></v-text-field>
        </template>

        <v-autocomplete
          v-model="listaAccionesSeleccionadas"
          :items="listaAcciones"
          item-value="idAccion"
          item-text="descripcion"
          attach
          chips
          prepend-icon="mdi-format-list-bulleted"
          label="Codigo de Cierre de Tareas"
          multiple
          persistent-hint
        >
        </v-autocomplete>

        <template v-if="subAccionModel == true">
          <v-autocomplete
            v-model="subAccionesSeleccionadas"
            :items="listaSubAcciones"
            item-value="idSubAccion"
            item-text="descripcion"
            attach
            chips
            prepend-icon="mdi-format-list-bulleted"
            label="Codigo de Cierre de Sub Acciones"
            multiple
            persistent-hint
          >
          </v-autocomplete>
        </template>

        <v-card color="#1F7087">
          <v-card-title class="text-h5"> Agregar Materiales </v-card-title>
          <v-data-table
            :headers="cabeceras"
            :items="tablaMateriales"
            sort-by="Material"
            class="elevation-1"
            no-results-text="No se encontraron resultados"
            no-data-text="No ha cargado Ningun Dato"
            :footer-props="$store.state.traduccionTabla"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Materiales</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-tooltip bottom mg="1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="blue"
                      small
                      fab
                      dark
                      @click="agregarMaterialALaLista"
                      class="ml-2"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar Material</span>
                </v-tooltip>

                <!-- <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  @click="agregarMaterialALaLista"
                >
                  Agregar Material
                </v-btn> -->
                <v-dialog v-model="dialogDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Desea quitar este Material de la lista?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="eliminarMaterialConfirmar"
                        >Eliminar Material</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:[`item.MaterialSeleccionadoNombre`]="props">
              <!-- <v-autocomplete
                v-model="props.item.idMaterial"
                :items="listaMateriales"
                item-value="idMaterial"
                item-text="nombre"
                label="Materiales"
                height="20"
                return-object
                no-data-text="No hay coincidencias"
                clearable
              ></v-autocomplete> -->
              <span>{{ props.item.idMaterial }} - {{ props.item.nombre }}</span>
            </template>

            <template v-slot:[`item.cantidad`]="props">
              <v-text-field
                v-model="props.item.cantidad"
                label="Cantidad"
                type="number"
              ></v-text-field>
            </template>

            <!-- <template v-slot:[`item.medida`]="props">
              {{ props.item.itg_unidad }}
            </template> -->

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom mg="1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    small
                    fab
                    dark
                    @click="eliminarMaterial(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Material</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>

        <br />

        <v-card color="#1F7087">
          <v-card-title class="text-h5"> Agregar Bobinas </v-card-title>
          <v-data-table
            :headers="cabecerasBobinas"
            :items="tablaMaterialesBobinas"
            sort-by="Material"
            class="elevation-1"
            no-results-text="No se encontraron resultados"
            no-data-text="No ha cargado Ningun Dato"
            :footer-props="$store.state.traduccionTabla"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Bobinas</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-tooltip bottom mg="1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      color="blue"
                      small
                      fab
                      dark
                      @click="agregarMaterialBobinaALaLista"
                      class="ml-2"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </template>
                  <span>Agregar Bobina</span>
                </v-tooltip>

                <v-dialog v-model="dialogBobinaDelete" max-width="500px">
                  <v-card>
                    <v-card-title class="text-h5"
                      >Desea quitar este Material de la lista?</v-card-title
                    >
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="closeDelete"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="eliminarMaterialBobinaConfirmar"
                        >Eliminar Bobina</v-btn
                      >
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <!-- <template v-slot:[`item.MaterialSeleccionadoNombre`]="props">
              <v-autocomplete
                v-model="props.item.MaterialSeleccionadoNombre"
                :items="listaMaterialesBobinas"
                item-value="idMaterialCable"
                :item-text="
                  (item) => `${item.idMaterialCable} - ${item.descripcionCable}`
                "
                label="Cable"
                height="20"
                return-object
                @change="cambioMaterialCable(props.item)"
                no-data-text="No hay coincidencias"
                clearable
              ></v-autocomplete>
            </template> -->

            <template v-slot:[`item.MaterialSeleccionadoNombre`]="props">
              <!-- <v-text-field v-model="props.item.MaterialSeleccionadoNombre">
              </v-text-field> -->
              <span>
                {{ props.item.MaterialSeleccionadoNombre }}
              </span>
            </template>

            <!-- <template v-slot:[`item.Bobina`]="props">
              <v-autocomplete
                v-model="props.item.Bobina"
                :items="props.item.Bobina"
                item-value="idBobinaC"
                item-text="idBobinaC"
                label="Bobinas"
                height="20"
                return-object
                no-data-text="No hay coincidencias"
                clearable
                @change="cambioBobinaCable(props.item)"
              ></v-autocomplete>
            </template> -->

            <template v-slot:[`item.Bobina`]="props">
              <span>
                {{ props.item.Bobina }}
              </span>
            </template>

            <template v-slot:[`item.cantidadDisponible`]="props">
              <v-text-field
                v-model="props.item.cantidadDisponible"
                label="Cantidad Disponible"
                type="number"
                readonly
              ></v-text-field>
            </template>

            <template v-slot:[`item.secInicio`]="props">
              <v-text-field
                v-model="props.item.secInicio"
                label="Secuencia Inicio Original"
                type="number"
                readonly
              ></v-text-field>
            </template>

            <template v-slot:[`item.secFin`]="props">
              <v-text-field
                v-model="props.item.secFin"
                label="Secuencia Fin Original"
                type="number"
                readonly
              ></v-text-field>
            </template>

            <template v-slot:[`item.secInicioIngresar`]="props">
              <v-text-field
                v-model="props.item.secInicioIngresar"
                label="Secuencia Inicio Inspeccion"
                clearable
                type="number"
              ></v-text-field>
            </template>

            <template v-slot:[`item.secFinIngresar`]="props">
              <v-text-field
                v-model="props.item.secFinIngresar"
                label="Secuencia Fin Inspeccion"
                clearable
                type="number"
              ></v-text-field>
            </template>

            <template v-slot:[`item.cantidadTotalM`]="{ item }">
              <span>
                {{ Math.abs(item.secFinIngresar - item.secInicioIngresar) }}
              </span>
            </template>

            <template v-slot:[`item.cantidadTotalMInspeccion`]="{ item }">
              <v-text-field
                v-model="item.cantidadMetrosInspeccion"
                label="Cantidad de Metros Inspeccion"
                clearable
                type="number"
              ></v-text-field>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <v-tooltip bottom mg="1">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    color="red"
                    small
                    fab
                    dark
                    @click="eliminarMaterialBobina(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>Eliminar Bobina</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>

        <!-- <template v-if="idCuadrillaSesion == ''">
          <v-select
            v-model="cuadrillaSeleccion"
            :items="cuadrillas"
            item-value="idCuadrilla"
            item-text="nameCuadrilla"
            :menu-props="{ maxHeight: '400' }"
            :rules="[Validaciones.requerido]"
            :readonly="readonlyContrator"
            prepend-icon="mdi-badge-account-outline"
            no-data-text="No se encontraron cuadrillas"
            :hint="hintContratista"
            persistent-hint
          ></v-select>
        </template> -->

        <v-btn class="mt-5" color="primary" @click="finalizarInspeccion()">
          Finalizar Inspeccion
        </v-btn>
      </v-col>
    </v-form>
    <dialog-mensaje ref="dialogMensaje" @resultado="confirmarCierreCuadrilla" />
  </v-container>
</template>

<script>
import axios from "axios";
import dialogMensaje from "@/components/modalMensaje.vue";
export default {
  components: {
    dialogMensaje,
  },
  data() {
    return {
      OTSeleccionada: 0,
      dialogBobinaDelete: false,
      tablaMaterialesBobinas: [],
      listaAccionesSeleccionadas: [],
      listaAcciones: [],
      subAccionesSeleccionadas: [],
      listaSubAcciones: [],
      subAccionModel: false,
      //idTarea: "",
      listaTareasSeleccionadas: [],
      listaCodigosCierreNuevos: [],
      listaCodigosCierreOriginal: [],
      arregloCopia: [],
      tablaMaterialesOriginales: [],
      tablaMaterialesModificados: [],
      tablaMaterialesNuevos: [],
      idTareaSeleccionada: "",
      idCuadrillaSesion: "",
      dialogDelete: false,
      editedItem: {
        cantidad: 0,
        medida: "",
        MaterialSeleccionado: null,
        MaterialSeleccionadoNombre: null,
        MaterialSeleccionadoId: null,
        cantidadDisponible: 0,
        cantidadIngresar: 0,
        nombre: "",
      },
      observacion: "",
      idEstadoInspeccion: "",
      listaMateriales: [
        {
          idMaterial: 1,
          nombre: "Material 1",
        },
        {
          idMaterial: 2,
          nombre: "Material 2",
        },
        {
          idMaterial: 3,
          nombre: "Material 3",
        },
        {
          idMaterial: 4,
          nombre: "Material 4",
        },
        {
          idMaterial: 5,
          nombre: "Material 5",
        },
      ],
      cabecerasBobinas: [
        {
          text: "Material",
          value: "MaterialSeleccionadoNombre",
          class: "black white--text",
        },
        {
          text: "Bobina",
          value: "Bobina",
          class: "black white--text",
        },
        // {
        //   text: "Cantidad Disponible",
        //   value: "cantidadDisponible",
        //   class: "black white--text",
        // },
        // {
        //   text: "Secuencia Inicio Original",
        //   value: "secInicio",
        //   class: "black white--text",
        // },
        // {
        //   text: "Secuencia Fin Original",
        //   value: "secFin",
        //   class: "black white--text",
        // },
        // {
        //   text: "Secuencia Inicio Inspeccion",
        //   value: "secInicioIngresar",
        //   class: "black white--text",
        // },
        // {
        //   text: "Secuencia Fin Inspeccion",
        //   value: "secFinIngresar",
        //   class: "black white--text",
        // },
        {
          text: "Cantidad de Metros",
          value: "cantidadTotalM",
          class: "black white--text",
        },
        {
          text: "Cantidad de Metros Inspeccion",
          value: "cantidadTotalMInspeccion",
          class: "black white--text",
        },
        {
          text: "Acciones",
          value: "actions",
          class: "black white--text",
        },
      ],
      tablaMateriales: [],
      cuadrillas: [],
      idTarea: "",
      cuadrillaSeleccion: "",
      formTitle: "",
      datosTarea: "",
      colorDialogTitle: "",
      dialog: false,
      formValid: null,
      alertShow: false,
      isSaving: false,
      show1: false,
      hintContratista: "Seleccione el contratista",
      contraseñaPH: "Contraseña",
      readonlyContrator: false,
      SeleccionContratista: "Selección",
      empleados: [],
      empleadoSeleccionados: [],
      contratistas: [],
      contratistaSeleccion: null,
      tipoModal_IdCuadrilla: 0,
      Usuario: "",
      password: "",
      NroOT: "",
      cabeceras: [
        {
          text: "Material",
          value: "MaterialSeleccionadoNombre",
          class: "black white--text",
        },
        //{ text: "Nombre Material", value: "NombreMaterial" },
        { text: "Cantidad", value: "cantidad", class: "black white--text" },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          class: "black white--text",
        },
      ],
      Validaciones: {
        requeridoSelect: (v) =>
          v.length > 0 || "Debe seleccionar al menos un empleado",
        requerido: (v) => !!v || "Campo Requerido",
        requeridopassword: (v) => {
          if (v == null && this.tipoModal_IdCuadrilla === 0) {
            return "Mínimo 6 caracteres";
          }
          if (this.tipoModal_IdCuadrilla === 0) {
            !!v || "Campo Requerido";
          }
          if ((v == null || v === "") && this.tipoModal_IdCuadrilla > 0) {
            return true;
          } else if (v.length < 6) {
            return "Mínimo 6 caracteres";
          }

          return true;
        },
      },
    };
  },

  async mounted() {
    const datos = this.$route.params.tareaSeleccionada;
    console.log("Los datos recibidos son: ");
    console.log(datos);
    this.idTareaSeleccionada = datos.idTarea;
    console.log("El id de la tarea seleccionada: ");
    console.log(this.idTareaSeleccionada);
    this.idContratistaSeleccionado = datos.idContratista;
    this.idCajonSeleccionado = datos.idCajon;
    //this.recuperarTareasCargadas();
    await this.getListarMaterialesContratista();
    await this.getListarMaterialesUtilizadosXTarea();
    //await this.recuperarBobinas();
    await this.getListarMaterialesBobinasParaArmarCajonContratistaXOT();
    await this.recuperarBobinasUtilizadas();
    await this.getAcciones();
    await this.recuperarAccionesRegistradas();
  },

  watch: {
    async listaAccionesSeleccionadas() {
      this.subAccionModel = false;
      console.log("las acciones son:");

      for (const accionSeleccionada of this.listaAccionesSeleccionadas) {
        console.log(accionSeleccionada);
        if (accionSeleccionada === 32) {
          this.accionSeleccionada = accionSeleccionada;
          await this.getSubAcciones();
          this.subAccionModel = true;
        }
      }
    },
  },

  methods: {
    cambioMaterialCable(item) {
      // Buscar el material seleccionado en la listaMaterialesBobinasPrueba
      const materialSeleccionado = this.listaMaterialesBobinas.find(
        (material) =>
          material.idMaterialCable ===
          item.MaterialSeleccionadoNombre.idMaterialCable
      );
      console.log("El cable seleccionado es:");
      console.log(materialSeleccionado.bobina);

      item.cantidadDisponible = materialSeleccionado.cantidadMetros;
      // Si se encuentra el material, cargar las bobinas asociadas en la segunda columna
      if (materialSeleccionado) {
        // Cargar las bobinas dentro de la propiedad Bobina del item
        this.listaBobinas = materialSeleccionado.bobina;
        item.Bobina = materialSeleccionado.bobina;
        console.log("Bobina cargadas:", item.Bobina);
      } else {
        // Si no se encuentra un material, vaciar la lista de bobinas
        item.Bobina = [];
      }
    },

    async recuperarBobinas() {},

    async getListarMaterialesBobinasParaArmarCajonContratistaXOT() {
      console.log("Ingresos a cargar los materiales bobinas para armar cajon");
      this.url =
        this.$store.state.urlBase +
        "Material/recuperarMaterialesBobinaParaArmarCajonContratistaXOT?idOT=" +
        this.OTSeleccionada;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log(
          "la lista de Materiales bobinas del cajon de la cuadrilla es:"
        );
        console.log(respuesta.data);
        console.log(JSON.stringify(respuesta.data));
        this.listaMaterialesBobinas = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }

      var listaMaterialesFiltrada = this.listaMateriales.filter(
        (material) =>
          !this.listaMaterialesBobinas.some(
            (bobina) => bobina.idMaterialCable == material.idMaterial
          )
      );

      this.listaMateriales = listaMaterialesFiltrada;

      console.log("La lista de materiales bobinas filtrada es:");
      console.log(listaMaterialesFiltrada);
    },

    async recuperarAccionesRegistradas() {
      console.log("Ingresos a cargar las acciones para la inspecciones");
      this.url =
        this.$store.state.urlBase +
        "Task/recuperarAccionesRegistradas?idTarea=" +
        this.idTareaSeleccionada;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de kas acciones de la tarea:");
        console.log(respuesta.data);
        this.listaAccionesSeleccionadas = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    agregarMaterialBobinaALaLista(material) {
      console.log("La cantidad de materiales es");
      console.log(this.tablaMateriales.length);
      console.log("Ingreso en agregar bobina a la lista");
      if (this.editedIndex > -1) {
        Object.assign(
          this.tablaMaterialesBobinas[this.editedIndex],
          this.editedItem
        );
      } else {
        console.log("El ultimo registro es: ");
        console.log(
          this.tablaMaterialesBobinas[this.tablaMaterialesBobinas.length - 1]
        );
        if (this.tablaMaterialesBobinas.length == 0) {
          console.log("No hay registros en la tabla");
          this.vaciarEditedItem();
          this.tablaMaterialesBobinas.push(this.editedItem);
          // Cambia MaterialSeleccionado a MaterialSeleccionadoNombre
          this.tablaMaterialesBobinas[
            this.tablaMaterialesBobinas.length - 1
          ].MaterialSeleccionadoNombre = material.nombre;
          this.tablaMaterialesBobinas[
            this.tablaMaterialesBobinas.length - 1
          ].MaterialSeleccionadoId = material.idMaterial;
        } else {
          console.log("Ya hay registros");
          if (
            this.tablaMaterialesBobinas[this.tablaMaterialesBobinas.length - 1]
              .MaterialSeleccionadoNombre != null
          ) {
            console.log("Ha ingresado material en la tabla");
            if (
              this.tablaMaterialesBobinas[
                this.tablaMaterialesBobinas.length - 1
              ].secInicioIngresar != null ||
              this.tablaMaterialesBobinas[
                this.tablaMaterialesBobinas.length - 1
              ].secFinIngresar != null
            ) {
              console.log("Ha una cantidad distinta de null");
              if (
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].secInicioIngresar != 0 ||
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].secFinIngresar != 0
              ) {
                console.log("Ha una cantidad distinta de 0");
                this.vaciarEditedItem();
                this.tablaMaterialesBobinas.push(this.editedItem);
                // Cambia MaterialSeleccionado a MaterialSeleccionadoNombre
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].MaterialSeleccionadoNombre = material.nombre;
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].MaterialSeleccionadoId = material.idMaterial;
              }
            }
          }
        }
      }
      console.log("Estoy hay en la tabla de bobinas: ");
      console.log(this.tablaMaterialesBobinas);
    },

    agregarMaterialBobinaALaLista2(material) {
      console.log("La cantidad de materiales es");
      console.log(this.tablaMateriales.length);
      console.log("Ingreso en agregar bobina a la lista");
      if (this.editedIndex > -1) {
        Object.assign(
          this.tablaMaterialesBobinas[this.editedIndex],
          this.editedItem
        );
      } else {
        console.log("El ultimo registro es: ");
        console.log(
          this.tablaMaterialesBobinas[this.tablaMaterialesBobinas.length - 1]
        );
        if (this.tablaMaterialesBobinas.length == 0) {
          console.log("No hay registros en la tabla");
          this.vaciarEditedItem();
          this.tablaMaterialesBobinas.push(this.editedItem);
          // Cambia MaterialSeleccionado a MaterialSeleccionadoNombre
          this.tablaMaterialesBobinas[
            this.tablaMaterialesBobinas.length - 1
          ].MaterialSeleccionadoNombre = material.nombre;
          this.tablaMaterialesBobinas[
            this.tablaMaterialesBobinas.length - 1
          ].MaterialSeleccionadoId = material.idMaterial;
        } else {
          console.log("Ya hay registros");
          if (
            this.tablaMaterialesBobinas[this.tablaMaterialesBobinas.length - 1]
              .MaterialSeleccionadoNombre != null
          ) {
            console.log("Ha ingresado material en la tabla");
            if (
              this.tablaMaterialesBobinas[
                this.tablaMaterialesBobinas.length - 1
              ].secInicioIngresar != null ||
              this.tablaMaterialesBobinas[
                this.tablaMaterialesBobinas.length - 1
              ].secFinIngresar != null
            ) {
              console.log("Ha una cantidad distinta de null");
              if (
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].secInicioIngresar != 0 ||
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].secFinIngresar != 0
              ) {
                console.log("Ha una cantidad distinta de 0");
                this.vaciarEditedItem();
                this.tablaMaterialesBobinas.push(this.editedItem);
                // Cambia MaterialSeleccionado a MaterialSeleccionadoNombre
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].MaterialSeleccionadoNombre = material.nombre;
                this.tablaMaterialesBobinas[
                  this.tablaMaterialesBobinas.length - 1
                ].MaterialSeleccionadoId = material.idMaterial;
              }
            }
          }
        }
      }
      console.log("Estoy hay en la tabla de bobinas: ");
      console.log(this.tablaMaterialesBobinas);
    },

    eliminarMaterialBobinaConfirmar() {
      this.tablaMaterialesBobinas.splice(this.editedIndex, 1);
      this.closeDelete();
      //console.log("Esto hay en la tabla: ");
      //console.log(this.tablaMateriales);
    },

    async getAcciones() {
      console.log("Ingresos a cargar las acciones de cajon cuadrilla");
      this.url = this.$store.state.urlBase + "Task/recuperarAcciones";
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Materiales del cajon de la cuadrilla es:");
        console.log(respuesta.data);
        this.listaAcciones = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getSubAcciones() {
      console.log("Ingresos a cargar las sub acciones de cajon cuadrilla");
      this.url =
        this.$store.state.urlBase +
        "Task/recuperarSubAcciones?idAccion=" +
        "32";
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de sub acciones de la cuadrilla es:");
        console.log(respuesta.data);
        this.listaSubAcciones = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async recuperarTareasCargadas() {
      console.log("Ingresos a cargar los codigo de tareas");
      this.url =
        this.$store.state.urlBase +
        "Task/recuperarCodigosCierreTareasConcluidas?idTarea=" +
        this.idTareaSeleccionada;
      //this.url = this.$store.getters.urlBase + "Gang";
      console.log(this.url);
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de codigos de tareas es: ");
        console.log(respuesta.data);
        respuesta.data.forEach((elemento) => {
          this.listaCodigosCierreOriginal.push({
            idCodigoCierre: elemento.idTarea.toString(),
          });
        });
      } else {
        console.log("Error");
      }
      this.listaTareasSeleccionadas = respuesta.data;
      console.log("Lista de materiales originales:");
      console.log(this.listaCodigosCierreOriginal);
      return respuesta.data;
    },

    confirmarCierreCuadrilla() {},

    async recuperarBobinasUtilizadas() {
      try {
        const url =
          this.$store.state.urlBase +
          "Bobina/recuperarBobinasUtilizadas?idTarea=" +
          this.idTareaSeleccionada;

        const options = {
          method: "GET",
          headers: { "content-type": "application/json" },
        };

        const respuesta = await axios(url, options);

        if (respuesta.status === 200 && respuesta.data.length > 0) {
          console.log("la lista de bobinas utilizadas es:", respuesta.data);

          this.OTSeleccionada = respuesta.data[0].idOT;

          // var respuestaNueva = respuesta.data.reduce((acc, item) => {
          //   if (!acc.some((x) => x.idBobina === item.idBobina)) acc.push(item);
          //   return acc;
          // }, []);

          // 🔧 Transformar los datos para adaptarlos al formato que usa tu tabla
          this.tablaMaterialesBobinas = respuesta.data.map((bobina) => ({
            // Campo mostrado en el autocomplete de materiales
            // MaterialSeleccionadoNombre: {
            //   idMaterialCable: bobina.idMaterialCable,
            //   descripcionCable: bobina.descripcionCable,
            // },

            MaterialSeleccionadoNombre:
              bobina.idMaterialCable + " - " + bobina.descripcionCable,

            // Campo mostrado en el autocomplete de bobinas
            // Bobina: [
            //   {
            //     idBobinaC: bobina.idBobinaC,
            //     idBobina: bobina.idBobina,
            //   },
            // ],

            Bobina: bobina.idBobinaC,

            // Campos numéricos que se muestran o editan
            cantidadDisponible: bobina.cantidadDisponible ?? 0,
            secInicio: bobina.secInicio ?? 0,
            secFin: bobina.secFin ?? 0,

            // Campos para ingreso manual (vacíos por defecto)
            secInicioIngresar: bobina.secInicio ?? 0,
            secFinIngresar: bobina.secFin ?? 0,

            // Para cálculo en la tabla
            cantidadTotalM: Math.abs(
              (bobina.secFin ?? 0) - (bobina.secInicio ?? 0)
            ),

            cantidadMetrosInspeccion: Math.abs(
              (bobina.secFin ?? 0) - (bobina.secInicio ?? 0)
            ),

            // Otros campos útiles
            idBobina: bobina.idBobina,
            idBobinaC: bobina.idBobinaC,
            idMaterialCable: bobina.idMaterialCable,
            idOT: bobina.idOT,
          }));

          this.tablaMaterialesBobinas = [
            ...new Map(
              this.tablaMaterialesBobinas.map((item) => [item.idBobina, item])
            ).values(),
          ];
        } else {
          console.warn("No se encontraron bobinas para la tarea seleccionada");
          this.tablaMaterialesBobinas = [];
        }
      } catch (error) {
        console.error("Error al recuperar bobinas utilizadas:", error);
      }
    },

    // async recuperarBobinasUtilizadas() {
    //   this.url =
    //     this.$store.state.urlBase +
    //     "Bobina/recuperarBobinasUtilizadas?idTarea=" +
    //     this.idTareaSeleccionada;

    //   const options = {
    //     method: "GET",
    //     headers: {
    //       "content-type": "application/json",
    //     },
    //     url: this.url,
    //   };
    //   var respuesta = await axios(this.url, options);
    //   if (respuesta.status === 200) {
    //     console.log("la lista de bobinas utlizadas es:");
    //     console.log(respuesta.data);
    //     this.OTSeleccionada = respuesta.data[0].idOT;
    //     this.tablaMaterialesBobinas = respuesta.data;
    //   } else {
    //     console.log("Error");
    //   }
    // },

    async getListarMaterialesUtilizadosXTarea() {
      console.log("Ingresos a cargar los materiales utlizados");
      this.url =
        this.$store.state.urlBase +
        "Material/recuperarMaterialesUtilizadosXTarea?idTarea=" +
        this.idTareaSeleccionada;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Materiales utilizados:");
        console.log(respuesta.data);

        var respuestaNueva = respuesta.data.reduce((acc, item) => {
          if (!acc.some((x) => x.idMaterial === item.idMaterial))
            acc.push(item);
          return acc;
        }, []);

        respuestaNueva.forEach((elemento) => {
          this.arregloCopia.push({
            idMaterial: elemento.idMaterial.toString(),
            nombre: elemento.nombre,
            cantidad: elemento.cantidad,
          });
        });

        this.tablaMateriales = respuestaNueva;

        //const tablaOriginal = respuesta.data;
        //this.tablaMaterialesOriginales = tablaOriginal;
        //this.tablaMaterialesOriginales = respuesta.data;

        // this.tablaMateriales.forEach((item) => {
        //   this.tablaMaterialesOriginales.push(item);
        // });
        console.log("Lo que hay en la tabla materiales es");
        console.log(this.tablaMateriales);
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }

      return respuesta.data;
    },

    async getListarMaterialesCajonCuadrilla() {
      console.log("Ingresos a cargar los materiales de cajon cuadrilla");
      this.url =
        this.$store.state.urlBase +
        "Material/recuperarMaterialesCajonCuadrilla?idCuadrilla=" +
        this.idCuadrillaSesion;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Materiales del cajon de la cuadrilla es:");
        console.log(respuesta.data);
        this.listaMateriales = respuesta.data;
        //this.idOTTitulo = respuesta.data[0].idOT;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getListarMaterialesContratista() {
      console.log("Ingresos a cargar los materiales");

      this.url =
        `${this.$store.state.urlBase}Material/recuperarMaterialesContratista` +
        `?idContratista=${this.idContratistaSeleccionado}&idDistrito=${this.$store.getters.usuario.idDistrito}`;
      //this.url = this.$store.getters.urlBase + "Gang";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de Material es:");
        console.log(respuesta.data);
        this.OTSeleccionada = respuesta.data[0].idOT;
        this.listaMateriales = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getListarCuadrillaByContratista() {
      console.log("El contratista es");
      console.log(this.$store.getters.usuario.idContratista);

      // if (this.$store.getters.usuario.idContratista == null) {
      //   this.$store.getters.usuario.idContratista == 2;
      // }

      this.url =
        this.$store.getters.urlBase +
        "Cuadrilla?idContratista=" +
        this.$store.getters.usuario.idContratista;
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        // params: {
        //   idcontratista:
        //     this.$store.getters.usuario.idRol != 3
        //       ? this.contratistaSeleccion
        //       : this.$store.getters.idContratista,
        // },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);

      console.log("la lista de cuadrillas es:");
      console.log(respuesta.data);

      respuesta.data.forEach((item) => {
        console.log("El numero de cuadrilla es");
        console.log(item.cuadrilla);
        this.cuadrillas.push({
          nameCuadrilla: item.cuadrilla,
          idCuadrilla: item.idCuadrilla,
        });
      });
      console.log(this.cuadrillas);
    },

    async armarCajon() {
      var sobreStock = 0;

      this.tablaMateriales.forEach((material) => {
        if (material.CantidadIngresar > material.cantidad) {
          console.log("Hay un material que excede el limite");
          sobreStock = 1;
          return;
        }
      });

      if (sobreStock == 1) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Hay un/os material/es que excede el limite ",
          1,
          "red",
          "Aviso"
        );
        //this.mensajeError();
        return;
      }

      console.log("El id de la cuadrilla seleccionada es: ");
      console.log(this.cuadrillaSeleccion);

      if (this.cuadrillaSeleccion == null) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "No ha seleccionado una cuadrilla para asignarle el cajon de materiales",
          1,
          "red",
          "Aviso"
        );
        return;
      }

      var respuesta;

      this.url = this.$store.state.urlBase + "Cajon/ingresarCajon";
      //this.url = this.$store.state.urlBas/api;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      console.log("lo que hay en tabla de materiales es");
      console.log(this.tablaMateriales);

      let datosMaterial = [];

      this.tablaMateriales.forEach((material) => {
        console.log("El id del material es");
        console.log(material.MaterialSeleccionadoNombre.idMaterial);
        console.log("La cantidad del material es:");
        console.log(material.CantidadIngresar);
        datosMaterial.push({
          idMaterial: material.MaterialSeleccionadoNombre.idMaterial.toString(),
          cantidad: material.CantidadIngresar,
        });
      });

      var datos = {
        idContratista: this.$store.getters.usuario.idContratista,
        idCuadrilla: this.cuadrillaSeleccion,
        idOT: this.tablaMateriales[0].MaterialSeleccionadoNombre.idOT,
        listaMateriales: datosMaterial,
        idUsuario: this.$store.getters.usuario.user_id,
        idDistrito: this.$store.getters.usuario.idDistrito,
      };

      console.log("Los datos son");

      console.log(datos);

      respuesta = await axios
        .post(this.url, datos, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de concluir tarea es:");

      console.log(respuesta);

      if (respuesta == true) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Se ha ingresado la inspeccion de la tarea",
          1,
          "green",
          "Mensaje"
        );
      } else {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Ha ocurrido un problema",
          1,
          "red",
          "Aviso"
        );
      }

      this.$router.push({
        name: "Cajones",
      });
    },

    async finalizarInspeccion() {
      this.tablaMaterialesNuevos = [];
      this.listaCodigosCierreNuevos = [];
      var sobreStock = 0;
      let idsVistos = new Set();

      console.log("Esto hay en la tabla de materiales: ");
      console.log(this.tablaMateriales);

      //   this.tablaMateriales.forEach((material) => {
      //     if (material.CantidadIngresar > material.cantidad) {
      //       console.log("Hay un material que excede el limite");
      //       sobreStock = 1;
      //       return;
      //     }
      //   });
      // this.listaTareasSeleccionadas.forEach((codigoTarea) => {
      //   console.log("El tipo de campo es ");
      //   console.log(typeof codigoTarea.idTarea);
      //   // this.tablaMaterialesNuevos.push({
      //   //   idMaterial: material.idMaterial.idMaterial.toString(),
      //   //   cantidad: parseFloat(material.cantidad),
      //   // });
      // });

      for (var i = 0; i < this.listaTareasSeleccionadas.length; i++) {
        var idTareaSeleccionada = this.listaTareasSeleccionadas[i];
        var coincide = false;

        // Itera sobre cada tarea seleccionada
        for (var j = 0; j < this.listaCodigosCierreOriginal.length; j++) {
          var idCodigoCierreOriginal =
            this.listaCodigosCierreOriginal[j].idCodigoCierre;
          // console.log("En el for el id codigo actual es");
          // console.log(idTareaSeleccionada);
          // console.log("En el for el id codigo original es");
          // console.log(idCodigoCierreOriginal);
          // Si el idCodigoCierre coincide con alguna idTarea, marca que coincide y sal del bucle interno
          if (idCodigoCierreOriginal === idTareaSeleccionada) {
            coincide = true;
            break;
          }
        }

        // Si no hubo coincidencia, agrega el idCodigoCierre a la lista de no coincidentes
        if (!coincide) {
          console.log("Agrego el codigo nuevo a la lista ");
          console.log(idTareaSeleccionada);
          this.listaCodigosCierreNuevos.push(idTareaSeleccionada);
        }
      }

      console.log("Lista de materiales originales:");
      console.log(this.listaCodigosCierreOriginal);

      console.log("Lista de nuevos codigos de cierre son: ");
      console.log(this.listaCodigosCierreNuevos);

      // var listaCodigosCierreOriginal = [
      //   /* tu lista de códigos de cierre */
      // ];
      // var listaTareasSeleccionadas = [
      //   /* tu lista de tareas seleccionadas */
      // ];
      var codigoCierreEliminados = [];

      // Recorre la listaCodigosCierreOriginal
      for (var k = 0; k < this.listaCodigosCierreOriginal.length; k++) {
        var codigoCierre = this.listaCodigosCierreOriginal[k].idCodigoCierre;
        var encontrado = false;

        // Compara con cada registro en listaTareasSeleccionadas
        for (var l = 0; l < this.listaTareasSeleccionadas.length; l++) {
          var tareaSeleccionada = this.listaTareasSeleccionadas[l];

          console.log("En el for el id codigo original es");
          console.log(codigoCierre);

          console.log("En el for el id codigo actual es");
          console.log(tareaSeleccionada);

          // Si el código de cierre existe en la lista de tareas seleccionadas, marca como encontrado y termina el bucle
          if (codigoCierre === tareaSeleccionada) {
            encontrado = true;
            break;
          }
        }

        // Si el código de cierre no fue encontrado en la lista de tareas seleccionadas, agrégalo a la lista de codigoCierreEliminados
        if (!encontrado) {
          codigoCierreEliminados.push(codigoCierre);
        }
      }

      // La lista codigoCierreEliminados contiene ahora los registros que existen en listaCodigosCierreOriginal pero no en listaTareasSeleccionadas
      console.log("Los codigos de cierre eliminados son: ");
      console.log(codigoCierreEliminados);

      this.tablaMateriales.forEach((material) => {
        if (idsVistos.has(material.idMaterial)) {
          console.log(
            "Se ha encontrado un ID de material duplicado:",
            material.idMaterial
          );
          sobreStock = 2;
        } else {
          // Agregar el ID del material al conjunto de IDs vistos
          idsVistos.add(material.idMaterial.toString());
        }
      });

      this.tablaMateriales.forEach((material) => {
        console.log("El tipo de campo es ");
        console.log(typeof material.idMaterial);
        if (typeof material.idMaterial != "string") {
          this.tablaMaterialesNuevos.push({
            idMaterial: material.idMaterial.idMaterial.toString(),
            cantidad: parseFloat(material.cantidad),
          });
        }
      });

      this.tablaMateriales.forEach((material) => {
        console.log("El tipo de campo es ");
        console.log(typeof material.idMaterial);
        if (typeof material.idMaterial == "string") {
          this.arregloCopia.forEach((materialOriginal) => {
            if (material.idMaterial == materialOriginal.idMaterial) {
              if (material.cantidad != materialOriginal.cantidad) {
                this.tablaMaterialesModificados.push({
                  idMaterial: material.idMaterial.toString(),
                  cantidad: parseFloat(material.cantidad),
                });
              }
            }
          });
        }
      });

      var listaBobinas = [];

      this.tablaMaterialesBobinas.forEach((material) => {
        console.log("El tipo de campo es ");
        console.log(material);
        listaBobinas.push({
          idBobina: material.idBobina,
          cantidadInspeccion: material.cantidadMetrosInspeccion,
        });

        // if (typeof material.idMaterial == "string") {
        //   this.arregloCopia.forEach((materialOriginal) => {
        //     if (material.idMaterial == materialOriginal.idMaterial) {
        //       if (material.cantidad != materialOriginal.cantidad) {
        //         this.tablaMaterialesModificados.push({
        //           idMaterial: material.idMaterial.toString(),
        //           cantidad: parseFloat(material.cantidad),
        //         });
        //       }
        //     }
        //   });
        // }
      });

      //   for (let i = 0; i < this.tablaMaterialesNuevos.length; i++) {
      //     let materialModificado = this.tablaMaterialesNuevos[i];
      //     let idMaterialModificado = materialModificado.idMaterial;

      //     // Verificar si el idMaterial modificado está en los materiales originales
      //     let encontrado = this.tablaMaterialesOriginales.some(
      //       (materialOriginal) =>
      //         materialOriginal.idMaterial === idMaterialModificado
      //     );

      //     // Si se encuentra el idMaterial modificado en los originales, eliminarlo de los modificados
      //     if (encontrado) {
      //       this.tablaMaterialesNuevos.splice(i, 1);
      //       i--; // Decrementar el contador para compensar el cambio en la longitud del array
      //     }
      //   }

      console.log("Los materiales originales son:");
      console.log(this.arregloCopia);
      //console.log(this.tablaMaterialesOriginales);

      console.log("Los materiales nuevos son:");
      console.log(this.tablaMaterialesNuevos);

      console.log("Los materiales modificados son:");
      console.log(this.tablaMaterialesModificados);

      console.log("Las bobinas inspeccionadas son: ");
      console.log(listaBobinas);

      //   if (sobreStock == 1) {
      //     this.$refs.dialogMensaje.abrirMensajeDialog(
      //       "Hay un/os material/es que excede el limite ",
      //       1,
      //       "red",
      //       "Aviso"
      //     );
      //     //this.mensajeError();
      //     return;
      //   }

      if (sobreStock == 2) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Hay un/os material/es repetidos ",
          1,
          "red",
          "Aviso"
        );
        //this.mensajeError();
        return;
      }

      //   this.tablaMaterialesNuevos.forEach((material) => {
      //     if (material.idMaterial > material.cantidad) {
      //       console.log("Hay un material que excede el limite");
      //       sobreStock = 1;
      //       return;
      //     }
      //   });

      var respuesta;

      this.url = this.$store.state.urlBase + "Task/inspeccionarTarea";
      //this.url = this.$store.state.urlBas/api;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      //   console.log("lo que hay en tabla de materiales es");
      //   console.log(this.tablaMateriales);

      //   let datosMaterial = [];

      //   this.tablaMateriales.forEach((material) => {
      //     console.log("El id del material es");
      //     console.log(material.MaterialSeleccionadoNombre.idMaterial);
      //     console.log("La cantidad del material es:");
      //     console.log(material.CantidadIngresar);
      //     datosMaterial.push({
      //       idMaterial: material.MaterialSeleccionadoNombre.idMaterial.toString(),
      //       cantidad: parseFloat(material.CantidadIngresar),
      //     });
      //   });

      //   console.log("El id del coajo es:");
      //   console.log(this.tablaMateriales[0].MaterialSeleccionadoNombre.idCajon);

      if (
        this.tablaMaterialesModificados != [] ||
        this.tablaMaterialesNuevos == []
      ) {
        this.idEstadoInspeccion = 0;
      } else {
        this.idEstadoInspeccion = 1;
      }

      const uniqueElements = {};

      const materialesModificados = this.tablaMaterialesModificados.filter(
        (elemento) => {
          // Creamos una clave única basada en los dos campos
          const clave = elemento.idMaterial + "-" + elemento.cantidad;
          // Si la clave no está en el objeto de registros, añadimos el elemento al objeto y devolvemos true
          if (!uniqueElements[clave]) {
            uniqueElements[clave] = true;
            return true;
          }
          // Si la clave ya está en el objeto de registros, devolvemos false para filtrar el elemento
          return false;
        }
      );

      console.log("El id de usuario es: ");
      console.log(this.$store.getters.usuario.user_id);

      var datos = {
        materialesNuevos: this.tablaMaterialesNuevos,
        materialesModificados: materialesModificados,
        idTarea: this.idTareaSeleccionada,
        observacion: this.observacion,
        idEstadoInspeccion: this.idEstadoInspeccion,
        idUsuario: this.$store.getters.usuario.user_id,
        codigosCierreNuevos: this.listaCodigosCierreNuevos,
        codigosCierreEliminados: codigoCierreEliminados,
        listaBobinas: listaBobinas,
      };

      //   console.log("Los datos son");

      //   console.log(datos);

      respuesta = await axios
        .post(this.url, datos, config)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de concluir tarea es:");

      console.log(respuesta);

      if (respuesta == true) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Se registrado la inspeccion de tarea",
          1,
          "green",
          "Mensaje"
        );
      } else {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "Ha ocurrido un problema",
          1,
          "red",
          "Aviso"
        );
      }

      this.$router.push({
        name: "Tareas",
      });
    },

    async concluirTarea() {
      var respuesta;

      this.url = this.$store.state.urlBase + "Task/concluirTareaCuadrilla";

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      console.log("lo que hay en tabla de materiales es");
      console.log(this.tablaMateriales.MaterialSeleccionadoNombre);
      var datos = {
        Materiales: this.tablaMateriales.MaterialSeleccionadoNombre,
        idTarea: this.idTarea,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      console.log("Los datos son");

      console.log(datos);

      this.tablaMateriales.forEach((material) => {
        console.log("El material es:");
        console.log(material.MaterialSeleccionadoNombre);
        console.log(material.cantidad);
      });

      respuesta = await axios
        .post(this.url, config, datos)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de concluir tarea es:");

      console.log(respuesta);

      console.log(this.tablaTareasDespachadasCuadrilla);
    },

    eliminarMaterial(item) {
      this.editedIndex = this.tablaMateriales.indexOf(item);
      this.dialogDelete = true;
    },
    eliminarMaterialConfirmar() {
      this.tablaMateriales.splice(this.editedIndex, 1);
      this.closeDelete();
      //console.log("Esto hay en la tabla: ");
      //console.log(this.tablaMateriales);
    },
    closeDelete() {
      this.dialogDelete = false;
    },

    cambioMaterial(item) {
      // Aquí puedes realizar la lógica para obtener la cantidad disponible
      // Supongamos que tienes una función obtenerCantidadDisponible() que obtiene la cantidad disponible
      item.cantidad = item.MaterialSeleccionadoNombre.cantidad;
      //item.cantidad = obtenerCantidadDisponible(item.MaterialSeleccionadoNombre.idMaterial);
    },

    agregarMaterialALaLista() {
      console.log("Ingreso en agregar a la lista");
      if (this.editedIndex > -1) {
        Object.assign(this.tablaMateriales[this.editedIndex], this.editedItem);
      } else {
        console.log("El ultimo registro es: ");
        console.log(this.tablaMateriales[this.tablaMateriales.length - 1]);
        if (this.tablaMateriales.length == 0) {
          this.tablaMateriales.push(this.editedItem);
        } else {
          if (
            this.tablaMateriales[this.tablaMateriales.length - 1].cantidad != 0
          ) {
            this.tablaMateriales.push(this.editedItem);
          }
        }
      }
      console.log("Estoy hay en la tabla respuesto: ");
      console.log(this.tablaMateriales);

      //console.log(this.tablaMateriales[0].cantidad);
      //console.log(this.tablaMateriales[0].MaterialSeleccionadoNombre);
      this.close();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    abrirModalTareaCuadrilla(datos) {
      this.datosTarea = datos;
      this.colorDialogTitle = "green";
      //this.tipoModal_IdCuadrilla = tipo;
      //   if (this.tipoModal_IdCuadrilla != 0) {
      //     this.getCuadrillabyID(tipo);
      //   } else {
      //     this.empleados = [];
      //     this.contratistaSeleccion = [];
      //   }
      this.formDialog = "Ingrese los datos para concluir la tarea";
      console.log("Los datos de la tarea son");
      console.log(this.datosTarea);
      console.log(this.datosTarea.identificador);
      this.dialog = true;
    },
  },
};
</script>

<style></style>
